export const MIN_FILES_ALLOWED = 0;
export const MAX_FILES_ALLOWED = 1;
export const FILE_MODAL_ACTION_BUTTON_TEXT = 'Insert';
